import { render, staticRenderFns } from "./DefaultDetail.vue?vue&type=template&id=0d6d1ea2&"
import script from "./DefaultDetail.vue?vue&type=script&lang=js&"
export * from "./DefaultDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6d1ea2')) {
      api.createRecord('0d6d1ea2', component.options)
    } else {
      api.reload('0d6d1ea2', component.options)
    }
    module.hot.accept("./DefaultDetail.vue?vue&type=template&id=0d6d1ea2&", function () {
      api.rerender('0d6d1ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/DefaultDetail.vue"
export default component.exports